module.exports = __webpack_public_path__ + "img/icon_image.cda36d5c.svg";